export enum DateRanges {
  Today = 'today',
  Yesterday = 'yesterday',
  Last7days = 'last7days',
  Last30days = 'last30days',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  Custom = 'customRange',
}
